import React from 'react';
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';

const StarRating = ({ rating, size = 'text-lg', interactive = false, onRate }) => {
  const stars = [];

  for (let i = 1; i <= 5; i++) {
    if (interactive) {
      stars.push(
        <button
          key={i}
          type="button"
          onClick={() => onRate(i)}
          className={`${size} transition-colors duration-150 focus:outline-none ${
            i <= rating ? 'text-accent-500' : 'text-gray-300'
          } hover:text-accent-400`}
          aria-label={`Rate ${i} star${i > 1 ? 's' : ''}`}
        >
          <FaStar />
        </button>
      );
    } else {
      if (i <= Math.floor(rating)) {
        stars.push(
          <FaStar key={i} className={`${size} text-accent-500`} />
        );
      } else if (i === Math.ceil(rating) && rating % 1 !== 0) {
        stars.push(
          <FaStarHalfAlt key={i} className={`${size} text-accent-500`} />
        );
      } else {
        stars.push(
          <FaRegStar key={i} className={`${size} text-gray-300`} />
        );
      }
    }
  }

  return <div className="flex items-center gap-0.5">{stars}</div>;
};

export default StarRating;